import { motion } from 'motion/react'
import { HedvigSymbol } from 'ui/src/components/HedvigSymbol/HedvigSymbol'
import { tokens } from 'ui/src/theme/tokens.css'
import { icon } from './Flow04Claims.css'

export function HedvigChatIcon() {
  return (
    <motion.div
      className={icon}
      initial={{ opacity: 0, scale: 0.5 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{
        opacity: { duration: 0.15, ease: 'easeOut' },
        scale: { type: 'spring', stiffness: 380, damping: 18 },
      }}
    >
      <HedvigSymbol size="100%" color={tokens.colors.text.opaque.primary} />
    </motion.div>
  )
}
